<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='委托商：'>
          <el-input v-model='searchForm.customerName' size='mini' placeholder='请输入委托商'/>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brandNames' size='mini' placeholder='请输入品牌'/>
        </el-form-item>
        <el-form-item label='线路：'>
          <el-select v-model='searchForm.lineId' size='mini' filterable style='width:100%'
                     placeholder='请选择线路' value-key='id'>
            <el-option v-for='item in lineOption' :key='item.id' :label='item.line_name'
                       :value='item.id'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='结算起止时间：'>
          <el-date-picker v-model='searchForm.settlementStartTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='开始日期'/>
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.settlementEndTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' class='searchBtn' @click='addBtn'>新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'/>
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='fleetName' label='业务公司' align='center' min-width='180px'/>
          <el-table-column label='上下水' align='center' min-width='100'>
            <template slot-scope='scope'>
              {{ scope.row.flowType ? '下水' : '上水' }}
            </template>
          </el-table-column>
          <el-table-column label='运价类型' align='center' min-width='120'>
            <template slot-scope='scope'>
              {{ scope.row.freightType ? '固定运价' : '普通运价' }}
            </template>
          </el-table-column>
          <el-table-column prop='customerName' label='委托商' align='center' min-width='220'/>
          <el-table-column prop='departurePort' label='起' align='center'/>
          <el-table-column prop='arrivePort' label='止' align='center'/>
          <el-table-column prop='brandNames' label='品牌' align='center' min-width='80'/>
          <el-table-column prop='riverTransportationUnitPrice' label='江运单价' align='center'
                           min-width='100'/>
          <el-table-column prop='settlementStartTime' label='结算起' align='center'
                           min-width='100'/>
          <el-table-column prop='settlementEndTime' label='结算止' align='center' min-width='100'/>
          <el-table-column label='状态' align='center' min-width='100'>
            <template slot-scope='scope'>
              {{ scope.row.state ? '启用' : '停用' }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='200px' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='stopUsing(scope.row.id)'>停用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <commercial-car-price-form ref='commercialCarPriceFormRef' @searchBtn='searchBtn'/>
  </div>
</template>

<script>
import {commercialCarPriceList, commercialCarPriceStop} from '@/service/financial';
import {getSessionStore} from '@/config/mUtils';
import {baseUrl} from '@/config/env';
import CommercialCarPriceForm from './components/commercialCarPriceForm.vue';
import BatchImport from '@/components/batchImport';
import {publicSelectLine} from "@/service/vehiclelog";

export default {
  name: 'commercialCarPrice',
  components: {
    CommercialCarPriceForm,
    BatchImport,
  },
  data() {
    return {
      searchForm: {
        customerName: '',
        brandNames: '',
        lineId: '',
        settlementStartTime: '',
        settlementEndTime: '',
        page: 1,
        rows: 10,
      },
      defaultSearchForm: {},
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
      lineOption: [],
      uploadUrl: '/platform/riverTransportation/commercialCarPrice/import',
    };
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    this.searchBtn();
    this.getPublicSelectLine();
  },
  methods: {
    async getPublicSelectLine() {
      const {status, message, data} = await publicSelectLine({type: 2})
      if (status !== 0) return this.$message.warning(message)
      this.lineOption = data
    },
    // 新增
    addBtn() {
      this.$refs.commercialCarPriceFormRef.dialogOpen();
    },
    // 结束时间
    dateChange(val) {
      if (this.searchForm.settlementEndTime && this.searchForm.settlementStartTime && (this.searchForm.settlementEndTime <= this.searchForm.settlementStartTime)) {
        if (val === this.searchForm.settlementEndTime) this.searchForm.settlementEndTime = '';
        if (val === this.searchForm.settlementStartTime) this.searchForm.settlementStartTime = '';
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 导出数据
    exportData() {
      let token = getSessionStore('token');
      window.location.href = `${baseUrl}/platform/riverTransportation/commercialCarPrice/export?access_token=${token}&customerName=${this.searchForm.customerName}&brandNames=${this.searchForm.brandNames}&lineId=${this.searchForm.lineId}&settlementStartTime=${this.searchForm.settlementStartTime}&settlementEndTime=${this.searchForm.settlementEndTime}`;
    },
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getTableData();
    },
    // 重置
    resetBtn() {
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await commercialCarPriceList(this.searchForm);
      this.tableLoading = false;
      console.log(data);
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data.records;
      this.total = data.total;
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    stopUsing(id) {
      this.$confirm('你确认停用么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await commercialCarPriceStop(id);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this.getTableData();
        })
        .catch(() => {
        });
    },
    download() {
      window.location.href = '/file/商品车普价模板.xlsx';
    },
  },
};
</script>


<style lang='scss' scoped>
.massLoss-list {
  /*width:100%;*/
  padding: 20px 15px 0 25px;
  height: 100%;
  /*overflow: auto;*/
  .nav {
    /*width:100%;*/
    display: flex;
    /*align-items: center;*/
    /*height:30px;*/
    overflow: hidden;

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  ::v-deep .detail {
    .el-form-item {
      margin-bottom: 2px;

      .el-form-item__label {
        /*color: #060606;*/
        font-weight: 700;
      }
    }

    .lineId {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .lineId + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;
    padding: 10px 0 20px 20px;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(249, 166, 6);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }


      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding-right: 20px;
      }
    }
  }


  ::v-deep .add {
    .el-form-item__label {
      font-weight: 700;
    }

    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          .el-form-item {
            .el-form-item__error {
              left: 40px;
            }

            margin-bottom: 5px;

            .el-form-item__label {
              // width: 150px !important;
              /*color: #060606;*/
            }

          }

        }

        .repair {
          .el-input {
            width: 80%;
          }

          .el-form-item {
            .el-form-item__error {
              /*left: 41px;*/
              padding-top: 0px;
            }

            margin-bottom: 7px;

            .el-form-item__label {
              /*width: 155px  !important;*/
              /*color: #060606;*/
            }
          }

          .el-upload-list__item {
            width: 100px;
            height: 100px;
          }

          .el-upload--picture-card {
            width: 100px;
            height: 100px;
            lineId-height: 100px;
          }

          /*display: none;*/
          .imgUp {
            display: flex;
            flex-direction: column;

            .imgLength {
              display: flex;
              align-items: center;
              width: 100%;

              span {
                margin-left: auto;
                color: rgb(183, 183, 183);
                font-size: 16px;
              }
            }
          }
        }

      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      lineId-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }

  }

}

.tableContainer {
  margin: 10px 0 30px 0;
}

.exportButton {
  span {
    color: rgba(51, 136, 255, 1);
    margin-right: 10px;
    font-size: 14px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
